<template>
    <div class="box">
        <article class="media">
            <div class="media-content">
                <div class="content">
                    <p>
                        All your profile information is here:
                    </p>
                    <ul>
                        <li>
                            <router-link to="/profile" class="has-text-info" aria-label="reply">
                                Consignees
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/profile" class="has-text-info" aria-label="reply">
                                Invoice Details
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/profile" class="has-text-info" aria-label="reply">
                                Contact Details
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                name: this.$store.getters.getCurrentUser.info.name
            }
        },
        mounted () {

        }
    }
</script>

<style scoped>
    .box {
        min-height: 175px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Profile.vue